import Helpers from "../base/Helpers";

const selectors = {
  triggerElement: "[data-action='toggle-tab']",
  closeElement: "[data-action='close-tab']",
  triggerAttribute: "aria-controls"
};

function registerTabs() {
  const $triggerElement = $(selectors.triggerElement);

  $triggerElement.each(function (i, el) {
    $(el).on("click", event => {
      if (event.currentTarget.classList.contains("is-active") ) {
        return;
      }
      event.currentTarget.classList.add("is-active");
      event.currentTarget.setAttribute("aria-selected", "true");
      Helpers.getSiblings(event.currentTarget, ".is-active").forEach(function (item) {
        item.classList.remove("is-active");
        item.setAttribute("aria-selected", "false");
      });

      // Then, display the panel
      const tabPanelToShow = document.querySelector("#" + event.currentTarget.getAttribute(selectors.triggerAttribute));
      tabPanelToShow.setAttribute("aria-hidden", "false");
      

      Helpers.getSiblings(tabPanelToShow, '.TabPanel[aria-hidden="false"]').forEach(function (item) {
        item.setAttribute("aria-hidden", "true");
      });
    });
  });


  // Function for hiding
  const $closeElement = $(selectors.closeElement);
  $closeElement.each(function (i, el) {
    $(el).on("click", event => {
      Helpers.getSiblings(event.currentTarget, ".is-active").forEach(function (item) {
        item.classList.remove("is-active");
      });
      const tabPanelToHide = document.querySelector("#" + event.currentTarget.getAttribute(selectors.triggerAttribute));
      tabPanelToHide.setAttribute("aria-hidden", "true");
    })
  });

}

document.addEventListener("DOMContentLoaded", function () {
  registerTabs();
});

